export default ({ items, $watch }) => {
    
    if ( $watch.$insert ) {
        items.splice(0,0,$watch.$insert)
    } else if ( $watch.$delete ) {
        var index = items.findIndex(i => i._id == $watch._id);
            index > -1 && items.splice(index,1);
    } else if ( $watch.$update ) {
        var item = items.find(i => i._id == $watch._id);
        if ( !item ) return console.log('$watch.update !item',$watch);
        Object.keys($watch.$update).forEach((key) => {
            var obj = item;
            key.split('.').forEach((Key,i,arr) => { 
              if ( !obj ) return console.log('stop',i,obj,key.split('.')); 
              if ( i == arr.length - 1 ) { 
                if ( !isNaN(Key) && Array.isArray(obj) ) { 
                  if ( data.DB == 'campaigns' && arr[arr.length-2] == 'pages' ) {
                    var newPage = data.$update[key];
                    if ( obj.find(p => p.code == newPage.code) ) return;
                  } 
                  return obj.splice(parseInt(Key),0,data.$update[key]) 
                }
                obj[Key] = $watch.$update[key];
              } else {  
                obj = obj[Key];
              } 
            });
        });        
    }
}